var _circle, _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCancelled = function SvgCancelled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16ZM12.0936 5.90642C12.4353 6.24812 12.4353 6.80214 12.0936 7.14385L10.2374 9L12.0936 10.8562C12.4353 11.1979 12.4353 11.7519 12.0936 12.0936C11.7519 12.4353 11.1979 12.4353 10.8562 12.0936L9 10.2374L7.14384 12.0936C6.80214 12.4353 6.24812 12.4353 5.90641 12.0936C5.5647 11.7519 5.5647 11.1979 5.90641 10.8562L7.76256 9L5.90642 7.14385C5.56471 6.80214 5.56471 6.24812 5.90642 5.90642C6.24812 5.56471 6.80214 5.56471 7.14385 5.90642L9 7.76256L10.8562 5.90642C11.1979 5.56471 11.7519 5.56471 12.0936 5.90642Z",
    fill: "#F44336"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16,
    height: 16,
    rx: 8,
    stroke: "white",
    strokeWidth: 2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCancelled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Cancelled.172bd7032aa0016a992721bf4bfc70a1.svg";